import type { MouseEvent as ReactMouseEvent } from 'react';

export const spinIconOut = (e: ReactMouseEvent<HTMLElement>) => {
  const icon = e.currentTarget.querySelector('.btn-icon') as HTMLElement | null;
  if (!icon) return;
  icon.classList.add('btn-icon-spin-out');
  setTimeout(() => {
    icon.style.transition = 'none';
    icon.classList.remove('btn-icon-spin-out');
    icon.style.transform = 'rotate(0deg)';
    requestAnimationFrame(() => {
      icon.style.transition = '';
      icon.style.transform = '';
    });
  }, 400);
};
